import ERRORS from '~/constants/errors';

import { Rule } from './types';

export const annnualTurnoverRule: Rule = ({ businessDetails, isPropertyOwner, industries }) => {
  if (!businessDetails?.annualTurnover || !businessDetails.industry || !industries)
    return undefined;
  const turnoverErrpr = isPropertyOwner ? ERRORS.turnoverPropertyOwner : ERRORS.turnover;
  if (isPropertyOwner) {
    const propertyOwnerIndustryCode = businessDetails.propertyOwnerOccupation?.industryCode;
    if (!industries && !propertyOwnerIndustryCode) return undefined;
    const propertyIndustry = industries.find(
      (industry) => industry.industryCode === propertyOwnerIndustryCode
    );
    if (businessDetails.annualTurnover > (propertyIndustry?.limits?.turnover ?? 0)) {
      return turnoverErrpr;
    }
  } else if (businessDetails.annualTurnover > (businessDetails.industry?.limits?.turnover ?? 0)) {
    return turnoverErrpr;
  }
  return undefined;
};
